import type { Resource } from '../../';
export const general_errors_renderAlerts_title_inHydrationProd: Resource = {"default":"Encountered a hydration error."};
